import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";

export interface Props extends Dictionary<string, any> { }

export const props: StoreFeature<Props> = {};